module.exports = __webpack_public_path__ + "static/img/niushe3.0c7356f7.png";